<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div style="display: flex;margin-top: 10px;margin-bottom: 10px;">
          <el-radio-group v-model="rbgOpen" style="margin-top: 7px;">
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_EnableOpen') }}</el-radio>
            <el-radio :label="0">{{ $t('CargoMsg.Cargo_DisableOpen') }}</el-radio>
          </el-radio-group>
          <el-button style="margin-left: 20px;" type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button style="" type="primary" @click="onCancel">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
        </div>
        <div class="tabs-container" :disabled="true" style="position: relative;">
          <!--遮罩-->
          <div v-if="!rbgOpen" style="position: absolute; top: 0; left: 0;right: 0;bottom: 0; background-color: rgba(0,0,0,.2); cursor: not-allowed; z-index: 9" />
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :key="1" :label="$t('CargoMsg.Cargo_OceanExport')" name="seaExPort">
              <credit-config ref="seaExPort" lob="SE" />
            </el-tab-pane>
            <el-tab-pane :key="2" :label="$t('CargoMsg.Cargo_OceanImport')" name="seaImPort">
              <credit-config ref="seaImPort" lob="SI" />
            </el-tab-pane>
            <el-tab-pane :key="3" :label="$t('CargoMsg.Cargo_AirExport')" name="aeExPort">
              <credit-config ref="aeExPort" lob="AE" />
            </el-tab-pane>
            <el-tab-pane :key="4" :label="$t('CargoMsg.Cargo_AirImport')" name="aeImPort">
              <credit-config ref="aeImPort" lob="AI" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_RailwayExport')" name="reExPort">
              <credit-config ref="reExPort" lob="RE" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_RailwayImport')" name="riExPort">
              <credit-config ref="riExPort" lob="RI" />
            </el-tab-pane>
            <el-tab-pane :key="5" :label="$t('CargoMsg.Cargo_FbaSea')" name="fbaSea">
              <credit-config ref="fbaSea" lob="SE" />
            </el-tab-pane>
            <el-tab-pane :key="6" :label="$t('CargoMsg.Cargo_FbaAir')" name="fbaAir">
              <credit-config ref="fbaAir" lob="AE" />
            </el-tab-pane>
            <el-tab-pane :key="6" :label="$t('CargoMsg.Cargo_IntegratedJob')" name="integrateJob">
              <credit-config ref="integrateJob" lob="IE" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreditConfig from '@/views/cargo/v0/SystemMaintenance/components/CreditConfig'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import { getOfficeConfigList } from '@/api/user'

export default {
  name: 'MtCreditConfig',
  components: { CreditConfig },
  data() {
    return {
      rbgOpen: 1,
      configMap: null,
      result: [],
      activeTabName: 'seaExPort'
    }
  },
  async created() {
    // 页面初始化先从缓存获取，最后通过查询的新数据更新
    await cache.load(cacheName.CONFIG)
    this.rbgOpen = parseInt(cache.config.get('creditOpen'))
    await this.onComplete()
  },
  methods: {
    async onComplete() {
      const officeId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      await getOfficeConfigList({ officeId }).then(res => {
        this.result = res.data
        this.configMap = new Map()
        res.data.forEach(p => {
          this.configMap.set(p.configName, p.configValue || p.configParentValue || p.configDefValue)
        })
        this.handleClick()
        this.updateView()
      }).catch(() => {
        this.loading.close()
      })
      this.loading.close()
    },
    updateView() {
      this.rbgOpen = parseInt(this.configMap.get('creditOpen'))
    },
    async handleClick() {
      if (this.$refs[this.activeTabName]) {
        await this.$refs[this.activeTabName].updateView(this.configMap, this.result)
      }
    },
    onSave() {
      if (this.$refs[this.activeTabName]) {
        const obj = { name: 'creditOpen', value: this.rbgOpen.toString() }
        this.$refs[this.activeTabName].onSave(obj)
      }
    },
    onCancel() {
      this.onComplete()
    }
  }
}
</script>

<style scoped>

</style>
